import { useTheme } from '@vebox/etui-system';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { forwardRef, useImperativeHandle, createElement } from 'react';
import '../utilities/get-styleprop.js';
import '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div, Span } from '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import '../Icon/Icon.js';
import '@vebox/etui-icons';
import { icons } from '../Icon/icons.js';
import '../Icon/helper.js';
import '@vebox/etui-colors';
import '../ClickOutside/ClickOutside.js';
import '../Tooltip/Tooltip.js';
import Button from '../Button/Button.js';
import { useNavigation, useDayPicker } from 'react-day-picker';

const Navbar = /*#__PURE__*/forwardRef(({
  displayMonth,
  onMonthClick,
  onNavigationMonthChange,
  isMonthSelectorVisible,
  navigationYear,
  useMonthSelector
}, outerRef) => {
  const theme = useTheme();
  const {
    goToMonth,
    nextMonth,
    previousMonth,
    displayMonths
  } = useNavigation();
  const {
    locale,
    styles,
    formatters
  } = useDayPicker();
  const handleNextClick = () => {
    const targetDate = isMonthSelectorVisible ? new Date(navigationYear + 1, 0) : nextMonth;
    onNavigationMonthChange === null || onNavigationMonthChange === void 0 ? void 0 : onNavigationMonthChange(targetDate);
    goToMonth(targetDate);
  };
  const handlePreviousClick = () => {
    const targetDate = isMonthSelectorVisible ? new Date(navigationYear - 1, 0) : previousMonth;
    onNavigationMonthChange === null || onNavigationMonthChange === void 0 ? void 0 : onNavigationMonthChange(targetDate);
    goToMonth(targetDate);
  };
  useImperativeHandle(outerRef, () => ({
    goToMonth
  }));
  return /*#__PURE__*/createElement(Div, {
    className: "rdp-navbar",
    style: styles.caption
  }, /*#__PURE__*/createElement(Div, {
    visibility: displayMonths[0] === displayMonth ? 'visible' : 'hidden'
  }, /*#__PURE__*/createElement(Button, {
    disabled: !previousMonth,
    onClick: handlePreviousClick,
    small: true,
    iconOnly: true,
    iconProps: {
      glyph: icons.FILLED_ARROW_LEFT
    },
    styles: {
      root: {
        p: `${theme.spacing.xs}px`
      }
    }
  })), useMonthSelector && /*#__PURE__*/createElement(Button, {
    onClick: onMonthClick,
    small: true
  }, isMonthSelectorVisible ? navigationYear : formatters.formatCaption(displayMonth, {
    locale
  })), !useMonthSelector && /*#__PURE__*/createElement(Span, null, formatters.formatCaption(displayMonth, {
    locale
  })), /*#__PURE__*/createElement(Div, {
    visibility: displayMonths[displayMonths.length - 1] === displayMonth ? 'visible' : 'hidden'
  }, /*#__PURE__*/createElement(Button, {
    disabled: !nextMonth,
    onClick: handleNextClick,
    small: true,
    iconOnly: true,
    iconProps: {
      glyph: icons.FILLED_ARROW_RIGHT
    },
    styles: {
      root: {
        p: `${theme.spacing.xs}px`
      }
    }
  })));
});
Navbar.displayName = 'Navbar';

export { Navbar };
